import pipe from 'lodash/fp/pipe.js';
import { connect } from 'react-redux';
import getComponent from '#components/support/polling/support/withPollingOnMount.jsx';
import { getAppVersion } from '#actions/app/version.js';

const getContainer = C => {
  const mapDispatchToProps = dispatch => ({
    poll: () => {
      const POLLING_INTERVAL = 5000;
      dispatch(getAppVersion);
      const pollingId = setInterval(() => {
        dispatch(getAppVersion);
      }, POLLING_INTERVAL);

      return () => {
        clearInterval(pollingId);
      };
    },
  });

  return connect(undefined, mapDispatchToProps)(C);
};

export default pipe(getComponent, getContainer);
